// extracted by mini-css-extract-plugin
export default {"root":"uoTD_AWXK7xpevUtdzBk","placeHolderShimmer":"vuarOYg2s4g7Qju1Lxrq"};